import React, { FC } from 'react';
import InteractiveImageText from './components/interactiveImageText';
import { InteractiveImageProps } from './types/interactiveImage.types';
import { isEditorActive } from '@sitecore-jss/sitecore-jss-react';
import InteractiveImageHotspot from './components/interactiveImageHotspot';
import './styles.scss';

const InteractiveImage: FC<InteractiveImageProps> = (props) => {
  const isEE = isEditorActive();
  return (
    <section className="interactive-image">
      <div className="interactive-image__container">
        <InteractiveImageHotspot {...props} isEE={isEE} />
        <InteractiveImageText {...props} isEE={isEE} />
      </div>
    </section>
  );
};

export default InteractiveImage;
